import React from "react"
import { HiCheckCircle } from "react-icons/hi"
import "./ProvenFranchise.css"

const ProvenFranchise = () => {
  const systemBenefits = [
    "Proven technology stack and back-office infrastructure",
    "Recruiting and operational support",
    "National brand credibility",
    "Fast-track launch timeline (as little as 90 days)",
    "Low-overhead, high-margin model — no storefronts required",
  ]

  return (
    <section className='proven-franchise section section-green-light'>
      <div className='container'>
        <div className='proven-wrapper'>
          <div className='proven-heading animate-fade-up'>
            <h2 className='section-title'>
              Own a Proven Staffing Franchise Built for Professionals Like You
            </h2>
            <p className='section-subtitle'>
              The Cordova Franchise System gives you everything you need to
              launch and operate a winning staffing business — without the
              complexity of starting from scratch.
            </p>
          </div>
          <div className='proven-benefits'>
            {systemBenefits.map((benefit, index) => (
              <div
                key={benefit}
                className='proven-benefit animate-fade-up'
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <span className='benefit-icon'>
                  <HiCheckCircle />
                </span>
                <p>{benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProvenFranchise

